import api from "./apiService";

export function getMembers(page, limit, name, kycStatus) {
  return api
    .get(
      `admin/account/users?page=${page}&limit=${limit}&name=${name}&kycStatus=${kycStatus}`
    )
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}
export function getDeclineReason() {
  return api
    .get(`admin/kyc/decline-reasons`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getMemberDetails(memberId) {
  return api
    .get(`admin/account/users/${memberId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function approveMember(memberId) {
  return api
    .patch(`admin/kyc/approve/${memberId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function declineMember(memberId, data) {
  return api
    .patch(`admin/kyc/decline/${memberId}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function deactivationRequest() {
  return api
    .get(`admin/account/deactivation/`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function deactivationAction(id, data) {
  return api
    .patch(`admin/account/deactivation/${id}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getActiveSub(id) {
  return api
    .get(`admin/subscriptions/member/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getUserPaymentHistory(id, page, limit) {
  return api
    .get(`admin/payments/member/${id}?page=${page}&limit=${limit}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/member.js
// module id = null
// module chunks = 